import Icon from "@mui/icons-material/ReceiptLong";
import { ProjectTakhmeenReceiptList } from "./ProjectTakhmeenReceiptList";
import { ProjectTakhmeenReceiptCreate } from "./ProjectTakhmeenReceiptCreate";
import { ProjectTakhmeenReceiptEdit } from "./ProjectTakhmeenReceiptEdit";
import { ProjectTakhmeenReceiptShow } from "./ProjectTakhmeenReceiptShow";

export default {
  list: ProjectTakhmeenReceiptList,
  create: ProjectTakhmeenReceiptCreate,
  edit: ProjectTakhmeenReceiptEdit,
  show: ProjectTakhmeenReceiptShow,
  icon: Icon,
  label: "Takhmeen receipts",
  options: { label: "Takhmeen receipts" },
  name: "projectTakhmeenReceipts",
};
